<template>
  <base-page id="login">
    <div class="login-content">
      <img src="../assets/login-img.svg" width="230" alt="" style="margin-top: 5em;">
      <br>
      <img style="margin: 2em auto;" src="../assets/welcome.svg" alt="">
      <br>
      <button @click="auth">LOG IN</button>
    </div>
  </base-page>
</template>

<script>

export default {
  name: 'login',
  data () {
    return {
    }
  },
  mounted () {
    const isAuthenticated = this.$store.getters.isAuthenticated
    if (isAuthenticated) {
      console.log('User is already authenticated')
      this.redirectToNextRoute()
      return
    }

    const token = this.$router.currentRoute.query.token
    if (token) {
      // we got a shinny new token from Firebase, let's login the user
      this.login({token})
    }
  },
  methods: {
    auth () {
      // redirect to functions, handle OAuth flow there
      const query = this.$router.currentRoute.query
      const queryString = Object.keys(query).map(k => {
        return `${encodeURIComponent(k)}=${encodeURIComponent(query[k])}`
      }).join('&')
      this.$store.commit('START_LOADING')
      window.location.replace(`/auth?${queryString}`)
    },
    redirectToNextRoute () {
      const {nextRoute, ...query} = this.$router.currentRoute.query
      delete query.token
      console.log('redirecting to ', nextRoute)
      console.log('with query params ', query)
      this.$router.push({path: nextRoute || '/', query})
    },
    login ({token}) {
      return this.$store.dispatch('login', {token}).then(() => {
        this.redirectToNextRoute()
      })
    }
  }
}
</script>

<style scoped>
button {
  width: 117px;
  height: 33px;
  box-shadow: none;
  border-radius: 5px;
  color: #FFF;
  font-weight: bold;
  background-color: #30D891;
  border: none;
}
#login {
  height: 100vh !important;
  background-color: #17445F !important;
  position: relative;
}
#login > img {
  padding: 1em;
  margin: 1em;
}
.login-content {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
}
h1 {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue